import React from "react";
import { array, bool, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import BigNumber from "../../atoms/BigNumber";

import "./numberedStoryHeadline.m.css";

const NumberedStoryHeadline = ({ storyList, className = "", numberShow = true }) => {
  return (
    <div className="numbered-story-headline-wrapper">
      {storyList.map(({ story }, index) => (
        <div key={index} styleName="wrapper" className={className}>
          <div styleName="content" className="content numbered-story-headline">
            {numberShow && <BigNumber headlineNumber={[index + 1]} className="headline-number" />}
            <NewsHeadline iconEnd={true} story={story} cssStyleName="smallSize" />
          </div>
        </div>
      ))}
    </div>
  );
};

NumberedStoryHeadline.propTypes = {
  className: string,
  storyList: array,
  numberShow: bool,
};

export default NumberedStoryHeadline;
